import React, { ChangeEvent, useEffect, useState } from 'react'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import { clearCart, removeCartItem, replaceCartItem } from '../redux/reducers/cartReducer'

import './styles/Cart.scss'
import Button from '../components/Button/Button'
import { CartItem } from '../types/types'
import Spoiler from '../components/Spoiler/Spoiler'
import { useNavigate } from 'react-router-dom'


const Cart = () => {
  const cart = useAppSelector((state) => state.cartReducer)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const shiping = 21
  const taxPercent = .02
  const gst = .05
  const [total, setTotal] = useState(0)

  useEffect(()=> {
    setTotal(cart.reduce((a,b) => a + (b.product.price * b.count), 0))
  }, [cart, setTotal])

  const removeItem = (id: number) => {
    dispatch(removeCartItem(id))
  }

  const applyCartCount = (item: CartItem, value: number) => {
    let itemToApply = Object.assign({}, item , {count: value})
    dispatch(replaceCartItem(itemToApply))
  } 

  return (
    <main>
      <Breadcrumbs/>
      <section>
        <div className="cart">
          <div className="container">
            <h1>Shoping Cart</h1>
            {cart.length > 0 ?
            <div className="cart-wrapper">
              <div className="cart-table">
                    <table>
                      <colgroup>
                        <col span={1} style={{width: '50%'}}/>
                        <col span={1} style={{width: '15%'}}/>
                        <col span={1} style={{width: '15%'}}/>
                        <col span={1} style={{width: '15%'}}/>
                        <col span={1} style={{width: '5%'}}/>
                      </colgroup>
                      <thead>
                        <tr>
                          <td>Item</td>
                          <td>Price</td>
                          <td>Qty</td>
                          <td>Subtotal</td>
                          <td></td>
                        </tr>
                      </thead>
                      <tbody>
                        {cart.map(item => {
                          return (<tr key={item.id}>
                            <td className='cart-table-item'>
                              <img src={item.product.images[0]} alt="" />
                              <p>{item.product.title}</p>
                            </td>
                            <td className="price">
                              ${item.product.price}
                            </td>
                            <td>
                              <input type="number" max={1000} min={1} onChange={(e: ChangeEvent<HTMLInputElement>) => applyCartCount(item, parseInt(e.target.value) > 1000 ? 1000 : parseInt(e.target.value))} value={item.count > 1000 ? 1000 : item.count}/>
                            </td>
                            <td className="price">
                              ${item.product.price * item.count}
                            </td>
                            <td>
                            <Button action={() => removeItem(item.id)} variant='hollow' frontIcon={<CancelOutlinedIcon sx={{width: 20, height: 20}}/>}></Button>
                            </td>
                          </tr>)
                        })}
                      </tbody>
                    </table>
                    <div className="cart-table-wrapper">
                      <Button variant='filled' action={() => dispatch(clearCart())}>Clear Shopping Cart</Button>
                      <Button variant='filled' action={() => navigate('/products')}>Update Shopping Cart</Button>
                    </div>
              </div>
              <div className="cart-confirm">
                <h2>Summary</h2>
                <div className="cart-confirm-additional">
                  <Spoiler title={'Estimate Shipping and Tax'}>
                    <p>Enter your destination to get a shipping estimate.</p>
                  </Spoiler>
                </div>
                <div className="cart-confirm-total">
                  <div className="cart-confirm-total-item">
                    <p>Subtotal</p>
                    <p>${total}</p>
                  </div>
                  <div className="cart-confirm-total-item">
                    <p>Shipment</p>
                    <p>${shiping}</p>
                  </div>
                  <p className="cart-confirm-total__descr">(Standard Rate - Price may vary depending on the item/destination. TECS Staff will contact you.)</p>
                  <div className="cart-confirm-total-item">
                    <p>Tax</p>
                    <p>${(total * taxPercent).toFixed(2)}</p>
                  </div>
                  <div className="cart-confirm-total-item">
                    <p>GST({gst * 100}%)</p>
                    <p>${(total * gst).toFixed(2)}</p>
                  </div>
                  <div className="cart-confirm-total-item">
                    <p>Order Total</p>
                    <p className='bigger'>${(total + (total * taxPercent) + (total * gst) + shiping).toFixed(2)}</p>
                  </div>
                </div>
                <Button variant='filled' action={() => navigate('./checkout')} >Proceed to Checkout</Button>
              </div>
            </div>
            : <div className='empty'>
                <span>Your cart is empty!</span>
                <Button variant='filled' action={() => {navigate('/products')}}>Buy some stuff</Button>
              </div>}
          </div>
        </div>
      </section>
    </main>
  )
}

export default Cart